(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anina-casas-indice"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('anina-indice')) {
    class AninaIndice extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const btn = event.target.closest('[data-filtro]');
          if (!btn || !this.contains(btn)) return;
          this.filtrar(btn.dataset.filtro);
          this.querySelectorAll('[data-filtro]').forEach((b) => {
            const on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        };
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      filtrar(universo) {
        let algum = false;
        this.querySelectorAll('[data-grupo]').forEach((grupo) => {
          let visiveis = 0;
          grupo.querySelectorAll('.anina-indice__item').forEach((item) => {
            const ok = universo === 'todos' || item.dataset.universos.split(' ').includes(universo);
            item.hidden = !ok;
            if (ok) visiveis += 1;
          });
          grupo.hidden = visiveis === 0;
          const link = this.querySelector(`[data-letra-link="${grupo.dataset.grupo}"]`);
          if (link) link.classList.toggle('is-off', visiveis === 0);
          if (visiveis > 0) algum = true;
        });
        const vazio = this.querySelector('.anina-indice__vazio');
        if (vazio) vazio.hidden = algum;
      }
    }
    customElements.define('anina-indice', AninaIndice);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anina-hero"] && !Shopify.designMode) return;
  try {
    
  class AninaHero extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 7000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.userPaused = !this.hasAttribute('data-autoplay') || this.reduced;
      if (this.slides.length < 2) return;

      this.onClick = (e) => {
        const b = e.target.closest('[data-prev],[data-next],[data-dot]');
        if (!b) return;
        if (b.hasAttribute('data-prev')) this.go(this.index - 1, true);
        else if (b.hasAttribute('data-next')) this.go(this.index + 1, true);
        else if (b.hasAttribute('data-dot')) this.go(Number(b.dataset.dot), true);
      };
      this.onEnter = () => this.stop();
      this.onLeave = () => { if (!this.userPaused) this.start(); };
      this.onVisibility = () => (document.hidden ? this.stop() : this.onLeave());
      this.onTouchStart = (e) => { this.x0 = e.touches[0].clientX; };
      this.onTouchEnd = (e) => {
        if (this.x0 == null) return;
        const dx = e.changedTouches[0].clientX - this.x0;
        if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
        this.x0 = null;
      };
      this.onBlockSelect = (e) => {
        const i = this.slides.findIndex((s) => s === e.target || s.contains(e.target));
        if (i > -1) { this.stop(); this.go(i); }
      };

      this.addEventListener('click', this.onClick);
      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      this.addEventListener('focusin', this.onEnter);
      this.addEventListener('focusout', this.onLeave);
      this.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.addEventListener('touchend', this.onTouchEnd);
      document.addEventListener('visibilitychange', this.onVisibility);
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.go(0);
      if (!this.userPaused) this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('mouseenter', this.onEnter);
      this.removeEventListener('mouseleave', this.onLeave);
      this.removeEventListener('focusin', this.onEnter);
      this.removeEventListener('focusout', this.onLeave);
      this.removeEventListener('touchstart', this.onTouchStart);
      this.removeEventListener('touchend', this.onTouchEnd);
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    go(i, fromUser = false) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.slides.forEach((s, k) => {
        const on = k === this.index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', String(!on));
        s.inert = !on;
      });
      this.dots.forEach((d, k) => {
        if (k === this.index) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      if (fromUser && this.timer) this.start();
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

  }
  if (!customElements.get('anina-hero')) customElements.define('anina-hero', AninaHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anina-piramide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelectorAll('.anina-acordes:not([data-ready])');
    if (!root.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.forEach((list) => {
      list.dataset.ready = '';
      if (reduce || !('IntersectionObserver' in window)) {
        list.classList.add('is-in');
        return;
      }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            list.classList.add('is-in');
            io.disconnect();
          }
        });
      }, { threshold: 0.3 });
      io.observe(list);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anina-vitrine"] && !Shopify.designMode) return;
  try {
    
  class AninaTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      if (!this.tabs.length) return;
      this.more = this.querySelector('[data-more]');
      this.onClick = (e) => {
        const tab = e.target.closest('[role="tab"]');
        if (tab) this.select(tab);
      };
      this.onKey = (e) => {
        const i = this.tabs.indexOf(e.target);
        if (i < 0) return;
        let j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % this.tabs.length;
        if (e.key === 'ArrowLeft') j = (i - 1 + this.tabs.length) % this.tabs.length;
        if (e.key === 'Home') j = 0;
        if (e.key === 'End') j = this.tabs.length - 1;
        if (j === null) return;
        e.preventDefault();
        this.select(this.tabs[j]);
        this.tabs[j].focus();
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
    }

    select(tab) {
      this.tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = this.querySelector('#' + t.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = !on;
          if (on && this.more && panel.dataset.link) this.more.href = panel.dataset.link;
        }
      });
    }
  }
  if (!customElements.get('anina-tabs')) customElements.define('anina-tabs', AninaTabs);

  /* Carrossel manual: rolagem nativa (dedo, trackpad, teclado) + setas que
     avançam uma "página" de cards. Não passa sozinho. */
  class AninaCarrossel extends HTMLElement {
    connectedCallback() {
      this.trilho = this.querySelector('[data-trilho]');
      if (!this.trilho) return;
      this.anterior = this.querySelector('[data-anterior]');
      this.proximo = this.querySelector('[data-proximo]');
      this.progresso = this.querySelector('[data-progresso]');
      this.quadro = 0;
      this.onScroll = () => {
        if (this.quadro) return;
        this.quadro = requestAnimationFrame(() => {
          this.quadro = 0;
          this.atualizar();
        });
      };
      this.onAnterior = () => this.passar(-1);
      this.onProximo = () => this.passar(1);
      this.trilho.addEventListener('scroll', this.onScroll, { passive: true });
      this.anterior?.addEventListener('click', this.onAnterior);
      this.proximo?.addEventListener('click', this.onProximo);
      this.observador = new ResizeObserver(() => this.atualizar());
      this.observador.observe(this.trilho);
      this.atualizar();
    }

    disconnectedCallback() {
      this.trilho?.removeEventListener('scroll', this.onScroll);
      this.anterior?.removeEventListener('click', this.onAnterior);
      this.proximo?.removeEventListener('click', this.onProximo);
      this.observador?.disconnect();
      if (this.quadro) cancelAnimationFrame(this.quadro);
    }

    passo() {
      const item = this.trilho.querySelector('.anina-faixa__item');
      if (!item) return this.trilho.clientWidth;
      const estilo = getComputedStyle(this.trilho);
      const gap = parseFloat(estilo.columnGap) || 0;
      const largura = item.getBoundingClientRect().width + gap;
      const util = this.trilho.clientWidth - (parseFloat(estilo.paddingLeft) || 0) - (parseFloat(estilo.paddingRight) || 0);
      const visiveis = Math.max(1, Math.floor((util + gap) / largura));
      return largura * visiveis;
    }

    passar(direcao) {
      const calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.trilho.scrollBy({ left: direcao * this.passo(), behavior: calmo ? 'auto' : 'smooth' });
    }

    atualizar() {
      const t = this.trilho;
      const max = t.scrollWidth - t.clientWidth;
      const x = Math.abs(t.scrollLeft);
      this.toggleAttribute('data-sem-rolagem', max <= 2);
      if (this.anterior) this.anterior.disabled = x <= 2;
      if (this.proximo) this.proximo.disabled = x >= max - 2;
      if (this.progresso && t.scrollWidth > 0) {
        this.progresso.style.setProperty('--tam', String(Math.min(1, t.clientWidth / t.scrollWidth)));
        this.progresso.style.setProperty('--pos', String(max > 0 ? Math.min(1, x / max) : 0));
      }
    }
  }
  if (!customElements.get('anina-carrossel')) customElements.define('anina-carrossel', AninaCarrossel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
